import { signal } from '@preact/signals-react'

export const deviceListSignal = signal([])
export const deviceListLoadedSignal = signal(false)
export const deviceListErrorSignal = signal(null)